
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/e2open",
      function () {
        return require("private-next-pages/integrations/e2open.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/e2open"])
      });
    }
  